import React, { useEffect, useRef, useState } from "react";
import InputField from "../forms/input-field";
import AsyncCreateSelect from "../forms/async-create-select-field";
import { Field, useFormikContext } from "formik";
import { useNavigate } from "react-router-dom";
import {
  customerListAction,
  defaultBinLocationAction,
  newWareHouseListAction,
  wareHouseListAction,
} from "../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import excelImg from "../../assets/icons/excel.png";
import DownloadIcon from "../../assets/icons/download-icon";
import LoadingButtonSpinner from "../helper-components/loading-button-spinner";
import {
  downloadAllTemplates,
  downloadAllTemplatesJson,
} from "../helper-components/helper-function";
import PersonIcon from "../../assets/icons/person-icon";
import SearchField from "../forms/search-field";
import OutstandingBalanceInfo from "../helper-components/outstanding-bal-information";
import ItemsInputField from "../forms/items-input-field";
import AddButton from "../buttons/button";
import { goodsUserTemplateAction } from "../../redux/actions/purchase-action";
import AddressSidebar from "../common-components/address-bar";
import { MapPin, FileJson } from "lucide-react";
import { useHotkeys } from "../helper-components/use-hotkeys";
import SelectField from "../forms/select-field";
import AddressSidebarSales from "../common-components/address-bar-sales";
import moment from "moment";
import { fetchBillNumberAction } from "../../redux/actions/invoices-action";
import errorToast from "../helper-components/error-toast";
import { PastBillsIcon } from "../../assets/icons/invoice-header-icons";
import PastOrdersPanel from "./past-orders-panel";
import { customerViewAction } from "../../redux/actions/customer-action";
import { Funnel } from "recharts";
import PurchaseReturnSidePanel from "../purchase-section/purchase-return/purchase-return-side-panel";
import NewPartyPanel from "../common-components/new-party-panel";
const SalesPurchaseNavbar = ({
  isClone = false,
  pageType,
  pageName = "",
  currentPage = "",
  page = "",
  disabled = false,
  searchRef = {},
  name = "",
  section = "",
  importcsv = false,
  handleFileUpload = () => {},
  loading,
  tempalteArray = [],
  csvButtonText = "Import CSV",
  csvTemLoading = false,
  fetchCreditNoteFn = () => {},
  isCusInvNumRequired = true,
  // Shows the required star on Reference Invoice Number and Date (the screen validates them)
  isCusInvNumMandatory = false,
  clickedplus,
  autoDraft,
  docType = "",
  storeDetails = {},
  transfer = false,
  standAlone = true,
  // Create a new vendor/customer in a side panel instead of leaving the page
  quickCreateParty = false,
}) => {
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);
  const [addressPanel, setAddressPanel] = useState(false);
  const [pastBillsPanel, setPastBillsPanel] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const [headerConfig, setheaderConfig] = useState([]);
  const [defaultDroppingBin, setDefaultDroppingBin] = useState(null);
  const [open,setOpen]=useState(false);
  const navigate = useNavigate();
  const { errors, values, setFieldValue, setFieldError } = useFormikContext();
  const data = useFormikContext();
  const addressRef = useRef(null);
  const pastRef = useRef(null);
  const filtersRef=useRef(null);
  const [newPartyPanel, setNewPartyPanel] = useState(false);

  // "+ New Vendor/Customer": quick-create panel on this page when enabled,
  // otherwise the full Create Party page
  const openNewParty = () => {
    if (quickCreateParty) setNewPartyPanel(true);
    else navigate("/admin/add-customer");
  };

  // ─── Styles ───────────────────────────────────────────────────────────────
  const fieldLabelClass =
    "min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]";
  const fieldInputClass =
    "min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons";

  // ─── Warehouse list ───────────────────────────────────────────────────────
  const mapListToOptions = (data) =>
    data?.data?.map((item) => ({
      label: `${item?.warehouse_code ?? item?.store_code ?? "-"}${
        item?.warehouse_name ? ` - ${item.warehouse_name}` : ""
      }`,
      value: item?.warehouse_id,
    })) || [];

  const onListSuccess = (data) => setWarehouseList(mapListToOptions(data));
  const onListError = () => {};

  // ─── Bill number ─────────────────────────────────────────────────────────
  function fetchBillNumber(date) {
    const MAP = {
      poit: "purchase_invoice",
      pct: "purchase_credit_note",
      soit: "sales_invoice",
      sct: "sales_credit_note",
    };
    if (!MAP[name]) return;
    dispatch(
      fetchBillNumberAction(
        { backdate: date, doc_type: MAP[name] },
        (data) => setFieldValue(`${name}_custom_invoice_number`, data?.data || ""),
        (data) => errorToast(data?.message)
      )
    );
  }

  // ─── GSTIN ────────────────────────────────────────────────────────────────
  const fetchGstin = (cmrId) => {
    if (!cmrId) return;
    dispatch(
      customerViewAction(
        cmrId,
        (data) =>
          setFieldValue("cmr_gstin", data?.data?.[0]?.cmr_gstin ?? ""),
        () => {}
      )
    );
  };

  // ─── Config from localStorage ─────────────────────────────────────────────
  useEffect(() => {
    const raw = localStorage.getItem("ModPermission");
    const MAP = {
      gort: "grn_header",
      poit: "pi_header",
      pot: "po_header",
      prt: "pr_header",
      pct: "pcn_header",
      sott: "so_header",
      sodtt: "dn_header",
      soit: "si_header",
      srt: "sr_header",
      sct: "scn_header",
    };
    const configKey = MAP[name];
    if (!raw || !configKey) return;

    const parsed = JSON.parse(raw);
    const billingData = parsed.find((obj) => obj?.[configKey]);
    if (billingData?.[configKey]) {
      setheaderConfig(billingData[configKey]);
    }
  }, [loading]);

  // ─── Init ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    dispatch(newWareHouseListAction(onListSuccess, onListError));
    const today = moment().format("YYYY-MM-DD");
    if (page !== "view") fetchBillNumber(today);
    if (page !== "view" && !values?.[`${name}_reference_inv_date`]) {
      setFieldValue(`${name}_reference_inv_date`, today, false);
    }
    const binLabel =
      section === "sales" ? "default dropping bin" : "default receiving bin";
    dispatch(
      defaultBinLocationAction(
        section==="sales" ? { field: "default_dropping_bin" } : { field: "default_receiving_bin" } ,
        (data) => {
          const bin = data?.data ?? null;
          setDefaultDroppingBin(bin);
          setFieldValue("default_dropping_bin", bin, false);
          if (!bin) errorToast(`Select the ${binLabel}`);
        },
        () => errorToast(`Select the ${binLabel}`)
      )
    );
  }, []);

  // ─── Customer search ──────────────────────────────────────────────────────
  const loadOptions = (inputValue, field) =>
    new Promise((resolve) => {
      const onSuccess = (data) => {
        const options = [
          ...data.data.map((item) => ({
            value: item.cmr_id,
            label: item?.cmr_code + "-" + item?.cmr_first_name,
          })),
          {
            value: "new_customer",
            label: (
              <span className="text-primary">
                {section === "sales" ? "+ New Customer" : "+ New Vendor"}
              </span>
            ),
          },
        ];
        setLocalData(data.data);
        resolve(options);
      };
      const onError = () =>
        resolve([
          {
            value: "new_customer",
            label: (
              <span className="text-primary">
                {section === "sales" ? "+ New Customer" : "+ New Vendor"}
              </span>
            ),
          },
        ]);

      if (inputValue?.length > 0) {
        dispatch(
          customerListAction(
            { field, value: inputValue, isVendor: true },
            onSuccess,
            onError
          )
        );
      } else {
        resolve([]);
      }
    });

  // ─── Shared customer-select handler ──────────────────────────────────────
  const applySelectedCustomer = (customerData) => {
    if (!customerData) return;

    setFieldValue("cmr_code", {
      label: customerData?.cmr_code,
      value: customerData?.cmr_id,
    });
    setFieldValue("cmr_id", customerData?.cmr_id);
    setCustomerId(customerData?.cmr_id);
    setFieldValue("cmr_balance", parseFloat(customerData?.cmr_credit_balance));
    setFieldValue("cmr_phone_number", customerData?.cmr_phone_number);
    setFieldValue("cmr_tcs", customerData?.cmr_tcs);
    setFieldValue("cmr_tds", customerData?.cmr_tds);
    setFieldValue("cmr_name", {
      value: customerData?.cmr_id,
      label: customerData?.cmr_first_name,
    });
    fetchGstin(customerData?.cmr_id);

    const final_total_amount = Math.round(total_amount).toFixed(2);
    const round_off_value = (Math.round(total_amount) - total_amount).toFixed(2);
    setFieldValue(`${name}_tcs_or_tds_percentage_id`, "");
    setFieldValue(`${name}_tds_tcs_type`, "");
    setFieldValue(`${name}_tcs_or_tds_percentage`, 0);
    setFieldValue(`${name}_tcs_or_tds_amount`, 0);
    setFieldValue(`${name}_round_off_value`, round_off_value);
    setFieldValue(`${name}_total_amount`, final_total_amount);

    if (name === "poit" || name === "gort") {
      dispatch(
        goodsUserTemplateAction(
          customerData?.cmr_id,
          (data) => {
            const vendorTemplateData = data?.data?.vendorTemplateData;
            setFieldValue("vendorTemplate", [
              {
                documentType: `${vendorTemplateData?.cmr_vendor_name} - Template`,
                expectedHeaders: vendorTemplateData?.excel_columns,
              },
            ]);
          },
          () => {}
        )
      );
    }

    if (searchRef?.current) {
      setTimeout(() => {
        searchRef.current.focus();
        setFieldError("cmr_name", "");
      }, 0);
    }
  };

  const total_amount = values.data?.reduce(
    (total, item) => total + parseFloat(item.item_total_amount || 0),
    0
  );

  // ─── Hotkeys ──────────────────────────────────────────────────────────────
  useHotkeys("l", () => {
    if (addressRef.current && values?.cmr_name) addressRef.current.click();
  });
  useHotkeys("p", () => {
    if (pastRef.current && values?.cmr_name) pastRef.current.click();
  });
  useHotkeys(
    "f",
    () => {
      if (filtersRef.current && values?.cmr_name) {
        filtersRef.current.click();
      }
    },
    { enabled: pageType === "purchase return" && page !== "view" }
  );

  const handleToggle = (e) => {
    e.preventDefault();
    if (page !== "view") setFieldValue("is_local_purchase", !values.is_local_purchase);
  };

  const configFields = Array.isArray(headerConfig) ? headerConfig : [];

  const cfgMap = configFields.reduce((acc, f) => {
    if (f?.value) acc[f.value] = f;
    return acc;
  }, {});
  // const cfgLabel = (fieldValue, fallback) =>
  //   cfgMap[fieldValue]?.label ?? fallback;

  // const cfgVisible = (fieldValue) => {
  //   if (configFields.length === 0) return true; 
  //   return cfgMap[fieldValue]?.enabled === true;
  // };


  const renderConfigField = (cfg) => {
    if (!cfg?.enabled) return null;
    const { value, label } = cfg;

    switch (value) {
  
      case "cmr_gstin":
        return (
          <div key={value}>
            <ItemsInputField
              labelClass={fieldLabelClass}
              inputClass={fieldInputClass}
              disabled={true}
              name="cmr_gstin"
              label={label}
              isLabelReq={true}
              placeholder="GST Number"
              maxLength={15}
            />
          </div>
        );

      
      case "is_inter_state":
        return (
          <div key={value} className="flex flex-col">
            <label className={fieldLabelClass}>{label}</label>
            <Field
              name="is_inter_state"
              value={
                values?.is_inter_state === true
                  ? "Inter"
                  : values?.is_inter_state === false
                  ? "Intra"
                  : ""
              }
              disabled
              placeholder="Select GST Type"
              className="min-h-[40px] rounded-[8px] w-full bg-[--toggle-disabled-background] text-[#000000] border border-[--disabled-color] pl-2 text-sm cursor-not-allowed"
            />
          </div>
        );

    
      case "customer_invoice_number":
  
        if (!isCusInvNumRequired) return null;
        return (
          <div key={value}>
            <ItemsInputField
              labelClass={fieldLabelClass}
              inputClass={fieldInputClass}
              disabled={page === "view"}
              name="customer_invoice_number"
              label={label}
              isLabelReq={true}
              isRequired={isCusInvNumMandatory}
              placeholder="Enter Invoice Number"
              allowAll={true}
            />
          </div>
        );

      default: {
        if (value === `${name}_order_date`) {
          return (
            <div key={value}>
              <ItemsInputField
                labelClass={fieldLabelClass}
                inputClass={fieldInputClass}
                type="date"
                disabled={true}
                name={`${name}_order_date`}
                label={label}
                isLabelReq={true}
                isRequired={true}
                onChange={(e) => {
                  if (e?.target?.value) fetchBillNumber(e.target.value);
                }}
              />
            </div>
          );
        }

        if (value === `${name}_document_date`) {
          return (
            <div key={value}>
              <ItemsInputField
                labelClass={fieldLabelClass}
                inputClass={fieldInputClass}
                type="date"
                {...(name === "pot" && {
                  value: moment().format("YYYY-MM-DD"),
                })}
                // disabled={page === "view"}
                disabled={true}
                name={`${name}_document_date`}
                label={label}
                isLabelReq={true}
                isRequired={true}
              />
            </div>
          );
        }

        if (value === `${name}_delivery_date`) {
          return (
            <div key={value}>
              <ItemsInputField
                labelClass={fieldLabelClass}
                inputClass={fieldInputClass}
                type="date"
                // disabled={page === "view"}
                disabled={true}
                name={`${name}_delivery_date`}
                label={label}
                isLabelReq={true}
                isRequired={true}
              />
            </div>
          );
        }

        if (value === `${name}_reference_inv_date`) {
          return (
            <div key={value}>
              <ItemsInputField
                labelClass={fieldLabelClass}
                inputClass={fieldInputClass}
                type="date"
                // disabled={page === "view"}
                disabled={true}
                name={`${name}_reference_inv_date`}
                label={label}
                isLabelReq={true}
                isRequired={isCusInvNumMandatory}
              />
            </div>
          );
        }

        return null;
      }
    }
  };

  // ─── JSX ─────────────────────────────────────────────────────────────────
  return (
    <div className="flex flex-col">
      <AddressSidebarSales
        isClone={isClone}
        autoDraft={autoDraft}
        clickedplus={clickedplus}
        pageType={pageType}
        open={addressPanel}
        setOpen={setAddressPanel}
        id={
          !isClone && pageType === "sales"
            ? page === "add"
              ? customerId
              : values.cmr_id
            : values.cmr_id
        }
        pos_id={values?.pos_id}
        name={name}
        page={page}
        disabled={disabled || transfer}
        storeState={storeDetails?.store_state}
        transfer={transfer}
        standAlone={standAlone}
      />
      {
        pageType === "purchase return" && page !== "view" && (
          <PurchaseReturnSidePanel
                open={open}
                setOpen={setOpen}
            />
        )
      }
      <div className="mt-4 w-full">
        <div className="flex items-center gap-3 flex-wrap justify-between mb-2">
          {pageName === "purchase invoice" && cfgMap["is_local_purchase"]?.enabled!==false ? (
            <div className="flex items-center gap-4 flex-wrap">
              <div className="flex flex-row gap-3 items-center">
                <label className="text-[length:var(--purchase-invoice-toggle-label-fs)] font-[var(--purchase-invoice-toggle-label-fw)]">
                  {cfgMap["is_local_purchase"]?.label ?? "Local Purchase"}
                </label>
                <button
                  type="button"
                  onClick={handleToggle}
                  className={`relative inline-flex h-6 w-10 items-center rounded-full transition-colors duration-300 ease-in-out focus:outline-none ${
                    values.is_local_purchase
                      ? "bg-[var(--primary)]"
                      : "bg-[var(--purchase-invoice-toggle-bg)]"
                  }`}
                  aria-pressed={values.is_local_purchase}
                  aria-label="Toggle button"
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-300 ease-in-out ${
                      values.is_local_purchase ? "translate-x-5" : "translate-x-1"
                    }`}
                  />
                </button>
              </div>
              <div className="w-[240px]">
                <SelectField
                  containerClass="flex-1 min-full"
                  placeholder="Select Warehouse"
                  options={warehouseList}
                  label="On behalf of:"
                  id="on_behalf_of_name"
                  name="on_behalf_of_name"
                  isSearchable={true}
                  errMsgContainerClass="hidden"
                  handleSelected={(selectedOption) => {
                    setFieldValue("on_behalf_of_name", selectedOption.label);
                    setFieldValue("on_behalf_of_id", selectedOption.value);
                  }}
                  labelWidth="6rem"
                  isDisabled={!values.is_local_purchase || disabled}
                />
              </div>
            </div>
          ) : (
            <span />
          )}

          <div className="flex items-center gap-3 flex-wrap justify-end">
            {pageType === "purchase return" && page !== "view" && <AddButton
                ref={filtersRef}
                icon={<Funnel size={13} />}
                text={
                    <>
                    Load Items with Filters <span className="opacity-50">(F)</span>
                    </>
                }
                className={`flex shrink-0 items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px]
                            bg-[var(--general-button-bg)] cursor-pointer
                            border border-[var(--general-button-border)]
                            hover:bg-[var(--general-button-bg)]
                            ${
                              values?.[`${name}_pay_to_address`] && values?.[`${name}_ship_to_address`] && values?.cmr_name
                                ? "text-[var(--general-button-fg)]"
                                : "text-[var(--general-button-disabled-fg)] opacity-60 pointer-events-none"
                            }`}
                            
                onclkFn={() => {
                    setOpen(prev => !prev);
                }}
            />}
            {/* Address Details */}
            <AddButton
              ref={addressRef}
              icon={<MapPin size={13} />}
              text={
                <>
                  Address Details <span className="opacity-50">(L)</span>
                </>
              }
              className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] bg-[var(--general-button-bg)] cursor-pointer border border-[var(--general-button-border)] hover:bg-[var(--general-button-bg)] ${
                values?.cmr_name && defaultDroppingBin
                  ? "text-[var(--general-button-fg)]"
                  : `text-[var(--general-button-disabled-fg)] opacity-60 ${
                      values?.cmr_name ? "" : "pointer-events-none"
                    }`
              }`}
              onclkFn={() => {
                if (!defaultDroppingBin) return;
                setAddressPanel(!addressPanel);
              }}
            />

            {/* CR/DB */}
            {(name === "gort" ||
              name === "poit" ||
              name === "pot" ||
              name === "prt" ||
              name === "pct" ||
              name === "sodtt" ||
              name === "soit") && (
              <OutstandingBalanceInfo
                conClasss="conClasss flex items-center justify-between gap-7 bg-[var(--out-standing-bg)] px-3 rounded-lg border border-[var(--out-standing-border)] shadow-sm h-[44px] cursor-pointer"
                onClick={fetchCreditNoteFn}
                badgeText={<span className="flex items-center gap-2">CR/DB</span>}
              />
            )}

            {/* Import CSV */}
            {importcsv && !disabled && (
              <>
                {name === "pot" && (
                  <input
                    type="file"
                    accept=".csv,.json"
                    onChange={(e) => handleFileUpload(e, "vendor")}
                    className="hidden"
                    id="csv-upload"
                  />
                )}
                {name === "pot" ? (
                  <label htmlFor="csv-upload">
                    <div className="flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] bg-[var(--import-button-bg)] cursor-pointer border border-[var(--import-button-border)] hover:bg-[var(--import-button-bg)] text-[var(--import-button-fg)]">
                      <img width={20} height={30} src={excelImg} alt="excel-icon" />
                      <FileJson width="20px" height="20px" className="text-[var(--import-button-fg)]" />
                      {loading || csvTemLoading ? (
                        <LoadingButtonSpinner className="h-6 w-6 border-t-2 border-027A48" />
                      ) : (
                        <span>Import CSV / JSON</span>
                      )}
                    </div>
                  </label>
                ) : (
                  <AddButton
                    onclkFn={handleFileUpload}
                    icon={
                      <>
                        <img width={20} height={30} src={excelImg} alt="excel-icon" />
                        <FileJson width="20px" height="20px" className="text-[var(--import-button-fg)]" />
                      </>
                    }
                    text={
                      loading || csvTemLoading ? (
                        <LoadingButtonSpinner className="h-6 w-6 border-t-2 border-027A48" />
                      ) : (
                        <span>
                          {csvButtonText} / JSON
                        </span>
                      )
                    }
                    className="flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] bg-[var(--import-button-bg)] cursor-pointer border border-[var(--import-button-border)] hover:bg-[var(--import-button-bg)] text-[var(--import-button-fg)]"
                  />
                )}
                {name === "pot" && (
                  <>
                    <button
                      type="button"
                      title="Download CSV Template"
                      onClick={() => downloadAllTemplates(tempalteArray)}
                      className="border border-[var(--import-button-border)] rounded-[8px] px-[12px] h-[44px]"
                    >
                      <DownloadIcon fill="var(--success-color)" />
                    </button>
                    <button
                      type="button"
                      title="Download JSON Template"
                      onClick={() => downloadAllTemplatesJson(tempalteArray)}
                      className="border border-[var(--import-button-border)] rounded-[8px] px-[12px] h-[44px]"
                    >
                      <DownloadIcon fill="var(--success-color)" />
                    </button>
                  </>
                )}
              </>
            )}

            {/* Past Bills */}
            <AddButton
              ref={pastRef}
              icon={<PastBillsIcon />}
              text={
                <>
                  Past Bills <span className="opacity-50">(P)</span>
                </>
              }
              className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] bg-[var(--general-button-bg)] cursor-pointer border border-[var(--general-button-border)] hover:bg-[var(--general-button-bg)] ${
                values?.cmr_name
                  ? "text-[var(--general-button-fg)]"
                  : "text-[var(--general-button-disabled-fg)] opacity-60 pointer-events-none"
              }`}
              onclkFn={() => setPastBillsPanel(!pastBillsPanel)}
            />
          </div>
        </div>

        {/* Title */}
        <h3 className="mb-2 text-[var(--input-label-color)] font-bold text-[0.95rem] whitespace-nowrap">
          Vendor And Invoice Information
        </h3>

        {/* Field panel */}
        <div className="bg-[var(--add-billing-head-bg)] border-radius w-full p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-3 items-end">

            {/* ── FIXED: Vendor/Customer Code + Name (always shown, always first) ── */}
            <div className="flex gap-2 items-end h-fit">
              <div className="w-[140px] shrink-0">
                <SearchField
                  type="text"
                  label={`${
                    section === "sales"
                      ? "Customer"
                      : (values.is_local_purchase ? "Local " : "") + "Vendor"
                  } Code`}
                  disabled={disabled}
                  menuPortalTarget={document.body}
                  className="z-1"
                  isValidNewOption={true}
                  autoFocus={true}
                  name="cmr_code"
                  placeholder={`Enter ${
                    section === "sales" ? "Customer" : "Vendor"
                  } Code`}
                  onCreateOption={() => {}}
                  onNewCustomer={quickCreateParty ? openNewParty : undefined}
                  cusType={section === "sales" ? "Customer" : "Vendor"}
                  loadOptions={(e) => loadOptions(e, "cmr_code")}
                  onChange={(selectedOption, actionMeta) => {
                    if (actionMeta?.action === "clear") {
                      setFieldValue("cmr_code", "");
                      setFieldValue("cmr_name", "");
                      setFieldValue("cmr_gstin", "");
                      setFieldValue(`${name}_pay_to_address`, null);
                      setFieldValue(`${name}_ship_to_address`, null);
                    } else if (
                      selectedOption === "new_customer" ||
                      selectedOption?.value === "new_customer"
                    ) {
                      openNewParty();
                    } else {
                      const customerData = localData?.find(
                        (item) => item?.cmr_id === selectedOption?.value
                      );
                      applySelectedCustomer(customerData);
                    }
                  }}
                />
              </div>

              <div className="flex-1 min-w-0">
                <SearchField
                  type="text"
                  label={`${
                    section === "sales"
                      ? "Customer"
                      : (values.is_local_purchase ? "Local " : "") + "Vendor"
                  } Name`}
                  disabled={disabled}
                  menuPortalTarget={document.body}
                  className="z-1"
                  isValidNewOption={true}
                  autoFocus={true}
                  name="cmr_name"
                  placeholder={`Enter ${
                    section === "sales" ? "Customer" : "Vendor"
                  } Name`}
                  onCreateOption={() => {}}
                  onNewCustomer={quickCreateParty ? openNewParty : undefined}
                  cusType={section === "sales" ? "Customer" : "Vendor"}
                  loadOptions={(e) => loadOptions(e, "cmr_first_name")}
                  onChange={(selectedOption, actionMeta) => {
                    if (actionMeta?.action === "clear") {
                      setFieldValue("cmr_code", "");
                      setFieldValue("cmr_name", "");
                      setFieldValue("cmr_gstin", "");
                      setFieldValue(`${name}_pay_to_address`, null);
                      setFieldValue(`${name}_ship_to_address`, null);
                    } else if (
                      selectedOption === "new_customer" ||
                      selectedOption?.value === "new_customer"
                    ) {
                      openNewParty();
                    } else {
                      const customerData = localData?.find(
                        (item) => item?.cmr_id === selectedOption?.value
                      );
                      applySelectedCustomer(customerData);
                    }
                  }}
                />
              </div>
            </div>

            {/* ── CONFIGURABLE fields: rendered in config order, display:true only ── */}
            {configFields.length > 0
              ? configFields.map((cfg) => renderConfigField(cfg))
              : /* ── Fallback when config not yet loaded: render original hard-coded set ── */
                <>
                  <div>
                    <ItemsInputField
                      labelClass={fieldLabelClass}
                      inputClass={fieldInputClass}
                      disabled={true}
                      name="cmr_gstin"
                      label="GST Number"
                      isLabelReq={true}
                      placeholder="GST Number"
                      maxLength={15}
                    />
                  </div>

                  <div className="flex flex-col">
                    <label className={fieldLabelClass}>GST Type</label>
                    <Field
                      name="is_inter_state"
                      value={
                        values?.is_inter_state === true
                          ? "Inter"
                          : values?.is_inter_state === false
                          ? "Intra"
                          : ""
                      }
                      disabled
                      placeholder="Select GST Type"
                      className="min-h-[40px] rounded-[8px] w-full bg-[--toggle-disabled-background] text-[#000000] border border-[--disabled-color] pl-2 text-sm cursor-not-allowed"
                    />
                  </div>

                  {isCusInvNumRequired && (
                    <div>
                      <ItemsInputField
                        labelClass={fieldLabelClass}
                        inputClass={fieldInputClass}
                        disabled={page === "view"}
                        name="customer_invoice_number"
                        label="Reference Invoice Number"
                        isLabelReq={true}
                        isRequired={isCusInvNumMandatory}
                        placeholder="Enter Invoice Number"
                        allowAll={true}
                      />
                    </div>
                  )}

                  <div>
                    <ItemsInputField
                      labelClass={fieldLabelClass}
                      inputClass={fieldInputClass}
                      type="date"
                      disabled={true}
                      name={`${name}_order_date`}
                      label="Document Date"
                      isLabelReq={true}
                      isRequired={true}
                      onChange={(e) => {
                        if (e?.target?.value) fetchBillNumber(e.target.value);
                      }}
                    />
                  </div>

                  <div>
                    <ItemsInputField
                      labelClass={fieldLabelClass}
                      inputClass={fieldInputClass}
                      type="date"
                      {...(name === "pot" && {
                        value: moment().format("YYYY-MM-DD"),
                      })}
                      // disabled={page === "view"}
                      disabled={true}
                      name={`${name}_document_date`}
                      label="Due Date"
                      isLabelReq={true}
                      isRequired={true}
                    />
                  </div>

                  <div>
                    <ItemsInputField
                      labelClass={fieldLabelClass}
                      inputClass={fieldInputClass}
                      type="date"
                      // disabled={page === "view"}
                      disabled={true}
                      name={`${name}_delivery_date`}
                      label={
                        name === "pot"
                          ? "Delivery Date"
                          : section === "sales"
                          ? "Delivery Date"
                          : "Received Date"
                      }
                      isLabelReq={true}
                      isRequired={true}
                    />
                  </div>

                  <div>
                    <ItemsInputField
                      labelClass={fieldLabelClass}
                      inputClass={fieldInputClass}
                      type="date"
                      // disabled={page === "view"}
                      disabled={true}
                      name={`${name}_reference_inv_date`}
                      label="Reference Invoice Date"
                      isLabelReq={true}
                      isRequired={isCusInvNumMandatory}
                    />
                  </div>
                </>
            }
          </div>
        </div>
      </div>

      <PastOrdersPanel
        open={pastBillsPanel}
        setOpen={setPastBillsPanel}
        name={name}
        cmrId={values?.cmr_id}
        cmrName={values?.cmr_name?.label}
      />
      {quickCreateParty && (
        <NewPartyPanel
          open={newPartyPanel}
          setOpen={setNewPartyPanel}
          partyLabel={section === "sales" ? "Customer" : "Vendor"}
          defaultType={section === "sales" ? "individual" : "business"}
          defaultAssociations={
            section === "sales" ? {} : { is_vendor_cmr: true }
          }
          onCreated={(party) => {
            const created = {
              ...party,
              cmr_credit_balance: party?.cmr_credit_balance ?? 0,
            };
            setLocalData((prev) => [...(prev || []), created]);
            applySelectedCustomer(created);
          }}
        />
      )}
    </div>
  );
};

export default SalesPurchaseNavbar;